import React from 'react';
import PropTypes from 'prop-types';

import BackstageApi  from 'app/apis/backstage';
import Modal         from 'app/components/common/modal';
import StandardInput from 'app/components/common/standard-input';

class ModalNonprofitAltNames extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      namesStr: '',
      isPending: false,
    };

    this.onClose = this.onClose.bind(this);
    this.onChangeNamesStr = this.onChangeNamesStr.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  componentDidMount() {
    const namesStr = (this.props.nonprofit.altNames || []).join('\n');
    this.setState({namesStr});
  }

  onClose() {
    this.props.onClose();
  }

  onChangeNamesStr(event) {
    const namesStr = event.target.value;
    this.setState({namesStr});
  }

  onClickSave() {
    this.setState({isPending: true});
    BackstageApi.nonprofitsUpdateAltNames(this.props.nonprofit.id, this.altNames)
      .then(() => {
        this.props.onClose(true);
      })
      .catch((error) => {
        console.error(error);
        alert('oops - something went wrong');
      });
  }

  get altNames() {
    const arr = this.state.namesStr.split('\n').map(n => n.trim()).filter(n => n);
    const set = new Set(arr);
    return [...set];
  }

  render() {
    return (
      <Modal className="bform" onClose={this.onClose}>
        <h1 className="bform-h1">Alt Names</h1>
        <p>Alternative names are used just for the purpose of search. They don't show up anywhere. One name per line, plz.</p>

        <label className="bform-h3">Edit Names</label>
        <StandardInput type="textarea" name="namesStr" value={this.state.namesStr} onChange={this.onChangeNamesStr} label="Space Cats Shelter" />

        <label className="bform-h3">Preview</label>
        <ul>
          {this.altNames.map((altName, i) => {
            return <li key={i}>{altName}</li>;
          })}
        </ul>

        <div className="bform-actions">
          <div className="bform-actions-right">
            <button className="btn blue" onClick={this.onClickSave} disabled={this.state.isPending}>Save</button>
          </div>
        </div>
      </Modal>
    );
  }

}

ModalNonprofitAltNames.propTypes = {
  nonprofit: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

ModalNonprofitAltNames.defaultProps = {

};

export default ModalNonprofitAltNames;
